import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../context/UserContext';

/** Renders the route only when the user is NOT logged in.
 *  If already authenticated, redirects to /dashboard. */
export default function PublicRoute() {
  const { user, loadingUser } = useUser();

  if (loadingUser) return null;

  if (user) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
